import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "data-item__header" };
const _hoisted_2 = { class: "data-item__nav" };
const _hoisted_3 = { class: "data-item__title" };
const _hoisted_4 = { class: "data-item__meta" };
const _hoisted_5 = { class: "data-item__facts" };
const _hoisted_6 = {
    key: 0,
    class: "data-item__actions"
};
const _hoisted_7 = { class: "data-item__content" };
const _hoisted_8 = { class: "data-item__section" };
const _hoisted_9 = { class: "data-item__section-title mb-4" };
const _hoisted_10 = { class: "row" };
const _hoisted_11 = { class: "col" };
const _hoisted_12 = { class: "data-item__section-subtitle" };
const _hoisted_13 = { class: "data-item__section" };
const _hoisted_14 = { class: "data-item__section-title mb-4" };
const _hoisted_15 = { class: "delivery-items" };
const _hoisted_16 = { class: "table table--condensed" };
const _hoisted_17 = { class: "delivery-items__sku" };
const _hoisted_18 = { class: "delivery-items__title" };
const _hoisted_19 = ["onClick"];
const _hoisted_20 = { class: "delivery-items__sku" };
const _hoisted_21 = { class: "delivery-items__image" };
const _hoisted_22 = ["src"];
const _hoisted_23 = { class: "delivery-items__title" };
import { onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from "vue-router";
import deliveryRepository from "../services/DeliveryRepository";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import AppAddress from "@astina/paloma-shop-common-ui/src/components/AppAddress.vue";
import Fact from "@astina/paloma-common-ui/src/components/Fact.vue";
import ProductUtils from "@astina/paloma-shop-common-ui/src/services/ProductUtils";
import RouterUtils from "@astina/paloma-common-ui/src/util/RouterUtils";
import { isGranted } from "@astina/paloma-common-ui/src/services/AccessManager";
import config from '../services/PortalConfig';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeliveryView',
    emits: [
        'close',
        'prev',
        'next'
    ],
    setup(__props, { emit: __emit }) {
        const route = useRoute();
        const router = useRouter();
        const emit = __emit;
        const delivery = ref(null);
        const images = ref({});
        const customDataColumns = config.deliveries?.customDataColumns || [];
        onMounted(() => {
            loadDelivery();
        });
        watch(() => route.params, loadDelivery);
        function loadDelivery() {
            delivery.value = null;
            const deliveryId = RouterUtils.singleParam(route, 'id');
            deliveryRepository.get(deliveryId).then(d => {
                delivery.value = d;
                createImages();
            });
        }
        function createImages() {
            images.value = {};
            delivery.value.items
                .filter(item => item.image)
                .forEach(item => {
                const image = ProductUtils.createImage(item.image);
                if (image) {
                    images.value[item.sku] = image;
                }
            });
        }
        function onItemSelect(item) {
            if (!isGranted('PORTAL_CATALOG_VIEW')) {
                return;
            }
            router.push({ name: 'catalog', query: { sku: item.sku } }).catch(() => {
            });
        }
        // --
        function closeView() {
            emit('close');
        }
        function prevItem() {
            emit('prev');
        }
        function nextItem() {
            emit('next');
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["data-item delivery", { 'delivery--loading': !delivery.value }])
            }, [
                _createElementVNode("header", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("a", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (prevItem()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(Icon, { name: "angle-left" })
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (closeView()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(Icon, { name: "times" })
                        ]),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (nextItem()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(Icon, { name: "angle-right" })
                        ])
                    ]),
                    _cache[10] || (_cache[10] = _createTextVNode()),
                    (delivery.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('delivery.deliveryNumber')) + " " + _toDisplayString(delivery.value.deliveryNumber), 1),
                            _cache[9] || (_cache[9] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(Fact, {
                                        label: _ctx.$t('delivery.status'),
                                        value: _ctx.$t('delivery.status.' + delivery.value.status),
                                        variant: 'status-' + delivery.value.status
                                    }, null, 8, ["label", "value", "variant"]),
                                    _cache[5] || (_cache[5] = _createTextVNode()),
                                    (delivery.value.sent)
                                        ? (_openBlock(), _createBlock(Fact, {
                                            key: 0,
                                            label: _ctx.$t('delivery.sent'),
                                            value: _ctx.$dateTime(delivery.value.sent)
                                        }, null, 8, ["label", "value"]))
                                        : _createCommentVNode("", true),
                                    _cache[6] || (_cache[6] = _createTextVNode()),
                                    (delivery.value.targetDate && !delivery.value.delivered)
                                        ? (_openBlock(), _createBlock(Fact, {
                                            key: 1,
                                            label: _ctx.$t('delivery.targetDate'),
                                            value: _ctx.$date(delivery.value.targetDate) + (delivery.value.targetTime ? ' ' + delivery.value.targetTime : '')
                                        }, null, 8, ["label", "value"]))
                                        : _createCommentVNode("", true),
                                    _cache[7] || (_cache[7] = _createTextVNode()),
                                    (delivery.value.delivered)
                                        ? (_openBlock(), _createBlock(Fact, {
                                            key: 2,
                                            label: _ctx.$t('delivery.delivered'),
                                            value: _ctx.$dateTime(delivery.value.delivered)
                                        }, null, 8, ["label", "value"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _cache[8] || (_cache[8] = _createTextVNode()),
                                (_ctx.$isGranted('PORTAL_ORDERS_VIEW'))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(delivery.value.orders, (order) => {
                                            return (_openBlock(), _createBlock(_component_router_link, {
                                                key: order.orderId,
                                                to: { name: 'orders_order', params: { orderNumber: order.orderNumber } },
                                                class: "button button--outline"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('order.orderNumber')) + ": " + _toDisplayString(order.orderNumber), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["to"]));
                                        }), 128))
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ], 64))
                        : (_openBlock(), _createBlock(Spinner, {
                            key: 1,
                            loading: !delivery.value
                        }, null, 8, ["loading"]))
                ]),
                _cache[25] || (_cache[25] = _createTextVNode()),
                _createElementVNode("div", _hoisted_7, [
                    (delivery.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("h3", _hoisted_9, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('orders.delivery')) + " ", 1),
                                    _createVNode(Icon, {
                                        name: "shipping-fast",
                                        "icon-style": "light",
                                        class: "text-muted"
                                    })
                                ]),
                                _cache[12] || (_cache[12] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.$t('orders.recipient')), 1),
                                        _cache[11] || (_cache[11] = _createTextVNode()),
                                        _createVNode(AppAddress, {
                                            address: delivery.value.recipient
                                        }, null, 8, ["address"])
                                    ])
                                ])
                            ]),
                            _cache[24] || (_cache[24] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("h3", _hoisted_14, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('delivery.items')) + " ", 1),
                                    _createVNode(Icon, {
                                        name: "box",
                                        "icon-style": "light",
                                        class: "text-muted"
                                    })
                                ]),
                                _cache[23] || (_cache[23] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("table", _hoisted_16, [
                                        _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('delivery.itemSku')), 1),
                                                _cache[13] || (_cache[13] = _createTextVNode()),
                                                _cache[14] || (_cache[14] = _createElementVNode("th", null, null, -1)),
                                                _cache[15] || (_cache[15] = _createTextVNode()),
                                                _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('delivery.item_title')), 1),
                                                _cache[16] || (_cache[16] = _createTextVNode()),
                                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('delivery.item_quantity')), 1),
                                                _cache[17] || (_cache[17] = _createTextVNode()),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(customDataColumns), (customDataColumn) => {
                                                    return (_openBlock(), _createElementBlock("th", {
                                                        key: customDataColumn.name
                                                    }, _toDisplayString(_ctx.$t('delivery.item_custom_data.' + customDataColumn.name)), 1));
                                                }), 128))
                                            ])
                                        ]),
                                        _cache[22] || (_cache[22] = _createTextVNode()),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(delivery.value.items, (item, index) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: index,
                                                    onClick: _withModifiers(($event) => (onItemSelect(item)), ["prevent"])
                                                }, [
                                                    _createElementVNode("td", _hoisted_20, _toDisplayString(item.sku), 1),
                                                    _cache[18] || (_cache[18] = _createTextVNode()),
                                                    _createElementVNode("td", _hoisted_21, [
                                                        (images.value[item.sku])
                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                key: 0,
                                                                src: images.value[item.sku].url,
                                                                alt: ""
                                                            }, null, 8, _hoisted_22))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _cache[19] || (_cache[19] = _createTextVNode()),
                                                    _createElementVNode("td", _hoisted_23, [
                                                        (_ctx.$isGranted('PORTAL_CATALOG_VIEW'))
                                                            ? (_openBlock(), _createBlock(_component_router_link, {
                                                                key: 0,
                                                                to: { name: 'catalog', query: { sku: item.sku } }
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(item.name), 1)
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["to"]))
                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _createTextVNode(_toDisplayString(item.name), 1)
                                                            ], 64))
                                                    ]),
                                                    _cache[20] || (_cache[20] = _createTextVNode()),
                                                    _createElementVNode("td", null, _toDisplayString(item.quantity) + " " + _toDisplayString(item.quantityUnit), 1),
                                                    _cache[21] || (_cache[21] = _createTextVNode()),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(customDataColumns), (customDataColumn) => {
                                                        return (_openBlock(), _createElementBlock("td", {
                                                            key: customDataColumn.name
                                                        }, [
                                                            (customDataColumn.type === 'date')
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _createTextVNode(_toDisplayString(item.customData && _ctx.$date(item.customData[customDataColumn.name])), 1)
                                                                ], 64))
                                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                    _createTextVNode(_toDisplayString(item.customData && item.customData[customDataColumn.name]), 1)
                                                                ], 64))
                                                        ]));
                                                    }), 128))
                                                ], 8, _hoisted_19));
                                            }), 128))
                                        ])
                                    ])
                                ])
                            ])
                        ], 64))
                        : _createCommentVNode("", true)
                ])
            ], 2));
        };
    }
});
